module.exports = __webpack_public_path__ + "img/LowestItems.a8963938.jpg";